<template>
  <div class="material-list">
    <div class="material-block">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="6">
          <div class="tit">申请人/代理人举证</div>
        </el-col>
        <el-col :span="6" style="text-align: right">
          <el-button
            v-if="applicantMaterial.length > 0"
            type="text"
            @click="downAllFile('applicant')"
            >一键下载<i class="el-icon-download el-icon--right"></i
          ></el-button>
        </el-col>
      </el-row>
      <el-table
        :data="applicantMaterial"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column label="当事人名称" align="center">
          <template slot-scope="scope">
            <span class="upload_img">{{ scope.row.sign }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证据名称" align="center">
          <template slot-scope="scope">
            <template v-if="String(scope.row.remark).length < 18">
              {{ scope.row.remark ? scope.row.remark : scope.row.fileName }}
            </template>
            <template v-else>
              <el-tooltip
                effect="dark"
                popper-class="row-fileName"
                :content="
                  scope.row.remark ? scope.row.remark : scope.row.fileName
                "
                placement="top-start"
              >
                <div class="row-fileName-ov">
                  {{ scope.row.remark ? scope.row.remark : scope.row.fileName }}
                </div>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="objectProof" label="证明对象" align="center">
          <template slot-scope="scope">
            <template v-if="String(scope.row.objectProof).length < 18">
              {{ scope.row.objectProof }}
            </template>
            <template v-else>
              <el-tooltip
                effect="dark"
                popper-class="row-fileName"
                :content="scope.row.objectProof"
                placement="top-start"
              >
                <div class="row-fileName-ov">{{ scope.row.objectProof }}</div>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="证据附件"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.proofAttachment }} </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
              <!--v-if="scope.row.proofAttachment"-->
            <el-button
              @click="handleCheck(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.fileId && scope.row.proofAttachment != ''"
              type="text"
              size="small"
              @click="downfile('applicant', scope.row)"
              >下载</el-button
            >
            <template v-if="scope.row.allowDel">
              <el-button
                v-if="scope.row.delStatus != '0'"
                type="text"
                @click="delfile(scope.row)"
                icon="el-icon-delete"
                circle
              ></el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="举证质证" align="center" width="90">
          <template slot-scope="scope">
            <el-button
              v-if="
                !isWatch &&
                scope.row.evidenceStatus == '1' &&
                loginInfo.memberId != scope.row.creatorId &&
                (loginInfo.memberType == 'RESPONDENT' ||
                  loginInfo.memberType == 'RESPONDENT_AGENT')
              "
              :disabled="isClosed"
              @click="crossExamination(scope.row)"
              type="text"
              size="small"
              >质证
            </el-button>
            <el-button
              v-else
              @click="crossExamination(scope.row)"
              type="text"
              size="small"
              >查看质证</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="material-block">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="6">
          <div class="tit">被申请人/代理人举证</div>
        </el-col>
        <el-col :span="6" style="text-align: right">
          <el-button
            v-if="respondentMaterial.length > 0"
            type="text"
            @click="downAllFile('respondent')"
            >一键下载<i class="el-icon-download el-icon--right"></i
          ></el-button>
        </el-col>
      </el-row>
      <el-table
        :data="respondentMaterial"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column label="当事人名称" align="center">
          <template slot-scope="scope">
            <span class="upload_img">{{ scope.row.sign }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证据名称" align="center">
          <template slot-scope="scope">
            <template v-if="String(scope.row.remark).length < 18">
              {{ scope.row.remark ? scope.row.remark : scope.row.fileName }}
            </template>
            <template v-else>
              <el-tooltip
                effect="dark"
                popper-class="row-fileName"
                :content="
                  scope.row.remark ? scope.row.remark : scope.row.fileName
                "
                placement="top-start"
              >
                <div class="row-fileName-ov">
                  {{ scope.row.remark ? scope.row.remark : scope.row.fileName }}
                </div>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="objectProof" label="证明对象" align="center">
          <template slot-scope="scope">
            <template v-if="String(scope.row.objectProof).length < 18">
              {{ scope.row.objectProof }}
            </template>
            <template v-else>
              <el-tooltip
                effect="dark"
                popper-class="row-fileName"
                :content="scope.row.objectProof"
                placement="top-start"
              >
                <div class="row-fileName-ov">{{ scope.row.objectProof }}</div>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="证据附件"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.proofAttachment }} </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button
              @click="handleCheck(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.fileId && scope.row.proofAttachment != ''"
              type="text"
              size="small"
              @click="downfile('respondent', scope.row)"
              >下载</el-button
            >
            <template v-if="scope.row.allowDel">
              <el-button
                type="text"
                @click="delfile(scope.row)"
                icon="el-icon-delete"
                circle
              ></el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="举证质证" align="center" width="90">
          <template slot-scope="scope">
            <el-button
              v-if="
                !isWatch &&
                scope.row.evidenceStatus == '1' &&
                loginInfo.memberId != scope.row.creatorId &&
                (loginInfo.memberType == 'APPLICANT' ||
                  loginInfo.memberType == 'APPLICANT_AGENT')
              "
              :disabled="isClosed"
              @click="crossExamination(scope.row)"
              type="text"
              size="small"
              >质证
            </el-button>
            <el-button
              v-else
              @click="crossExamination(scope.row)"
              type="text"
              size="small"
              >查看质证</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="material-block">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="6">
          <div class="tit">其它材料</div>
        </el-col>
          <el-col :span="6" style="">
            <el-button
                v-if="mediatorMaterial.length > 0"
                type="text"
                @click="downAllFile('mediator')"
            >一键下载<i class="el-icon-download el-icon--right"></i
            ></el-button>
          </el-col>
      </el-row>
      <el-table
        :data="mediatorMaterial"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column label="当事人名称" align="center">
          <template slot-scope="scope">
            <span class="upload_img">{{ scope.row.sign }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证据名称" align="center">
          <template slot-scope="scope">
            <template v-if="String(scope.row.remark).length < 18">
              {{ scope.row.remark ? scope.row.remark : scope.row.fileName }}
            </template>
            <template v-else>
              <el-tooltip
                effect="dark"
                popper-class="row-fileName"
                :content="
                  scope.row.remark ? scope.row.remark : scope.row.fileName
                "
                placement="top-start"
              >
                <div class="row-fileName-ov">
                  {{ scope.row.remark ? scope.row.remark : scope.row.fileName }}
                </div>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="证明对象" align="center">
          <template slot-scope="scope">
            <template v-if="String(scope.row.objectProof).length < 18">
              {{ scope.row.objectProof }}
            </template>
            <template v-else>
              <el-tooltip
                effect="dark"
                popper-class="row-fileName"
                :content="scope.row.objectProof"
                placement="top-start"
              >
                <div class="row-fileName-ov">{{ scope.row.objectProof }}</div>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="证据附件"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.fileName !== ''"
              >共{{ scope.row.fileInfo.length }}项：
              <span>{{ scope.row.fileName }} </span>
            </span> -->
            <span>{{ scope.row.proofAttachment }} </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button
              @click="handleCheck(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.fileId && scope.row.proofAttachment != ''"
              type="text"
              size="small"
              @click="downfile('mediator', scope.row)"
              >下载</el-button
            >
            <template v-if="scope.row.allowDel">
              <el-button
                v-if="scope.row.delStatus != '0'"
                type="text"
                @click="delfile(scope.row)"
                icon="el-icon-delete"
                circle
              ></el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="举证质证" width="90" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="
                !isWatch &&
                scope.row.evidenceStatus == '1' &&
                loginInfo.memberId != scope.row.creatorId
              "
              :disabled="isClosed"
              @click="crossExamination(scope.row)"
              type="text"
              size="small"
              >质证
            </el-button>
            <el-button
              v-else
              @click="crossExamination(scope.row)"
              type="text"
              size="small"
              >查看质证</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
<!--    <template v-if="g_userBtn['uploadAttachment']">-->
      <div style="display: flex;flex-direction: row;justify-content: center">
          <el-button
              type="primary"
              @click="showUploadEvidence"
              class="upload-btn"
              style="margin: 0 25px;"
              v-if="!isClosed && canUpload && !isManage"
          >上传证据</el-button
          >
          <el-button
              type="primary"
              @click="batchImport()"
              class="upload-btn"
              style="margin: 0 25px;"
              v-if="!isClosed && canUpload && !isManage"
          >一键导入</el-button>
      </div>


<!--    </template>-->
    <el-dialog
      :visible.sync="dialogCaseinfoImg"
      width="50%"
      title="证据目录"
      custom-class="dialog-caseinfo"
      :before-close="handleClose"
    >
      <el-container style="display: flex;flex-direction: column;">
        <el-main>
          <filePreview
            :file-list="detailBean"
            :show-delte="detailBean.allowDel"
            @detelEvidenceFile="detelEvidenceFile"
            @close="close"
          ></filePreview>
        </el-main>
        <div style="display: flex;margin-left: 20px;">
          <div class="dialogContent" style="line-height: 32px;">上传附件：</div>
          <el-upload class="upload-demo"  multiple
             :on-change="handleChange" :action="actionUrl"
             :data="uploaddata" :accept="acceptType1" :headers="flk"
             :on-success="successother" :on-remove="fileremove"
             :before-upload="handleBefore" :on-exceed="handleExceed"
             :file-list="upfilelist"
          >
            <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
            <span class="el-upload__tip " style="margin-left: 20px">只能上传pdf/doc/docx/png/jpg/xls/xlsx文件，{{maxFileTip}}</span>
          </el-upload>
        </div>

      </el-container>
    </el-dialog>
    <UploadEvidence
      ref="uploadEvidence"
      :currentRoomId="currentRoomId"
      :ws="wsLink"
      :showEvidenceDialog="showUploadEvidenceDailog"
      @handleClose="handleClose"
      @getList="getList"
    ></UploadEvidence>
    <crossExamination
      v-if="showCrossExamination"
      ref="crossExamination"
      :isCrossExaminationRecord="currentFileIsCrossExaminationRecord"
      :createRoomData="createRoomData"
      :addEvidenceData="addEvidenceData"
      @comcallback="comcallback"
      @successHandler="getList"
    ></crossExamination>
    <!-- 批量导入弹窗 -->
    <el-dialog
            :visible.sync="this.batchImportDiolog"
            title="导入证据"
            width="576px"
            :before-close="closeDialog"
            center
            class="dialog_model"
    >
      <p class="dialog_line"></p>
      <div class="dialogContainer">
        <div class="dialogContent">选择文件：</div>
        <div class="uploadContent">
          <el-upload
              class="upload-demo"
              :action="actionUrl"
              :accept="acceptType"
              :on-success="successother"
              :on-remove="fileremove"
              :before-upload="handleBefore"
              multiple
              drag
              :headers="flk"
              :data="uploaddata"
              :file-list="imfilelist"
              :limit="1"
          >

            <!--:http-request="handleRequestRecord"-->
            <div class="el-btn-upload" >
              <i class="el-icon-upload2"></i> 点击上传
            </div>
            <div class="warn">只能上传xls、xlsx文件，且不能超过10M</div>
            <div class="excelTemplate" @click.stop="downloadTemplate" >
              <i class="el-icon-download"></i>
              模板下载
            </div>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="confirm_ca" @click="closeDialog">取 消</el-button>
        <el-button class="confirm_re" type="primary"  @click="submitQuestion"
        >导 入</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 11
import {
  evidenceList,
  queryLawAttachmentList,
  createRoom,
  delMediationMaterial,
  delEvidenceDetails,
  importProof
} from "@/api/user.js";
import filedownload from "@/utils/filedown.js";
import config from "@/config/config.js";
import AlertEmit from "@/views/caseSpace/components/alertEmit.js";
import { searchDictionaryInfo } from "@/api/common.js";
import { getStore, maxFileLength,maxFileTip, maxFileWarning } from "@/utils/utils.js";
import UploadEvidence from "@/components/uploadEvidence.vue";
import crossExamination from "@/components/crossExamination.vue";
// 按钮权限引入
import { userButton } from "@/common/js/buttonMixin.js";
import FilePreviewLIst from "./FilePreviewLIst.vue";
import {isManageRole} from "../../../utils/utils";
export default {
  components: {
    UploadEvidence,
    crossExamination,
    filePreview: FilePreviewLIst,
  },
  mixins: [userButton],
  data() {
    return {
      canUpload: true,
        maxFileTip:maxFileTip,
      dialogCaseinfoImg: false,
      // 控制质证界面是否展示
      showCrossExamination: false,
      // 控制上传界面的展示
      showUploadEvidenceDailog: false,
      currentFileIsCrossExaminationRecord: false,
      applicantMaterial: [], //申请人举证数据列表
      respondentMaterial: [], //被申请人举证数据列表
      mediatorMaterial: [], //其他材料数据回填
      detailBean: {}, //控制证据附件操作查看页面返回结果
      caseinfoImg: "",
      createRoomData: {},
      addEvidenceData: {},
      btnSubmiting: false,
      isClosed: localStorage.getItem("CloseState") == "true" ? true : false,
      wsLink: "",
      currentRoomId: "",
      isWorker: true,
      currentUserId: "",
      attachmentList: [],
      loginInfo: "",
      isWatch: false,
      isManage: false,
      batchImportDiolog: false,
      imfilelist: [],
      actionUrl: config.baseURL + "/gzzc/docBook/upload", //控制批量导入的内容
      acceptType: ".xls,.xlsx",
      uploaddata: {
          isView: "VIEW",
      },
      flk: {JWTToken: '', appName: 'gzzc',cType:'PC'},
      imfileId: '',
      upfilelist: [],
      acceptType1: ".pdf,.doc,.docx,.png,.jpg,.xls,.xlsx",
      upfileId: '',
      upType: ''
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.activeName == "third") {
      this.getList();
    }
    let wsInfo = this.$store.getters.getWSLink;
    if (wsInfo.hasOwnProperty("wsLink")) {
      this.wsLink = wsInfo.wsLink;
      this.currentRoomId = wsInfo.currentRoomId;
    } else {
      let currentRoomId =
        this.$route.query.roomid.indexOf(",") != -1
          ? this.$route.query.roomid.split(",")[0]
          : this.$route.query.roomid;
      this.$store
        .dispatch("initWSLink", {
          currentRoomId: currentRoomId,
        })
        .then((res) => {
          this.wsLink = res;
          this.currentRoomId = currentRoomId;
        });
    }

    AlertEmit.$on("getList", (args) => {
      if (args) {
        this.getList();
      }
    });

    this.loginInfo = JSON.parse(getStore("loginInfo"));
    this.isManage = isManageRole(this.loginInfo.userRoles)
    // console.log('登录存储信息', this.loginInfo)
    this.isWorker = this.loginInfo.personType === "STAFF" ? true : false;
    if (!this.isWorker) {
      this.canUpload = false;
      let data = getStore("canUpload");
      if (data != undefined) {
        this.canUpload = data == 1 ? true : false;
      }
    }
    if (this.loginInfo.memberType === "INVITATION_WATCHER") {
      this.isWatch = true;
    } else {
      this.isWatch = false;
    }
    this.currentUserId = this.loginInfo.memberId;
  },
  watch: {
    $route() {
      // this.isClosed = this.$route.query.isClosed == 'true' ? true : false
      if (this.$route.query.activeName == "third") {
        this.getList();
      }
    },
  },
  methods: {
      // 模板下载
      downloadTemplate() {
          console.log("我是模板下载");
          filedownload("/gzzc/docBook/preNoViewImg/Z3p6Y185MjkxZTk4MGU1NjA0NjEwYWNjMTUyMmI3NzNiODBkYQ==.xlsx",{},"template.xlsx")
      },
      handleExceed(){},
      handleChange() {},
      closeDialog() {
          this.batchImportDiolog = false;
          this.imfilelist = []
      },
      // 批量导入上传之前的回调
      handleBefore(file,accept) {
          let acceptType = this.upType === 'addFile' ? this.acceptType1 : this.acceptType
          if (file.size > this.maxFileTip) {
              this.$message({
                  type: 'warning',
                  message: maxFileWarning
              });
              return false
          }
          let tempRet = /\.[^.]+$/.exec(file.name)
          let isAcceptType = true
          if (tempRet) {
              if (!~acceptType.indexOf(tempRet[0])) {
                  isAcceptType = false
              }
          }
          if (!isAcceptType) {
              this.$message({
                  type: 'warning',
                  message: '文件只支持' + this.acceptType + '等格式'
              });
              this.filelist.pop()
              return false
          }
          this.flk.JWTToken = getStore('flk');
      },
      // 批量上传移除的回调
      fileremove(index) {
          console.log("批量上传移除的回调");
      },
      //批量导入成功的回调
      successother(res,file,fileList) {
          console.log(res ,file)
          if (res.code === 1000) {
              if (this.upType === 'importFile') {
                  this.imfilelist = fileList
                  this.imfileId = res.data.fileId
              }
              if (this.upType === 'addFile') {
                  this.upfilelist = fileList
                  this.upfileId = res.data.fileId
                  let item = {
                      id: this.detailBean.id,
                      fileId: this.upfileId,
                      delFlag: false,
                      fileName: file.name
                  }
                  this.detelEvidenceFile(item)
              }
          }
      },
      //批量导入
      batchImport() {
          this.upType = 'importFile'
          this.batchImportDiolog = true;
      },

      successUplod(response, file, fileList) {
          console.log(response)

      },
      submitQuestion() {
          if (!this.imfileId) {
              return this.$message.error('请先上传附件!')
          }
          let params = {
              caseId: this.$route.query.caseid,
              meetingId: this.$route.query.meetingid,
              fileId: this.imfileId
          }
          importProof(params).then(res => {
              if(res.data.code === 1000){
                  this.closeDialog()
                  this.getList();
                  this.imfileId = ''
                  this.imfilelist = []
                  this.$message.success('导入成功')
              }else{
                  this.$message.error(res.data.message)
              }
          })
      },
    crossExamination(item) {
      console.log(item)
      this.currentFileIsCrossExaminationRecord = item.isCrossExaminationRecord;
      let addEvidenceParams = {
        attachmentId: item.id,
        caseId: this.$route.query.caseid,
        meetingId: this.$route.query.meetingid,
        // meetingId: item.meetingId
      };
      this.addEvidenceData = addEvidenceParams;
      this.showCrossExamination = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    showUploadEvidence() {
      // this.$refs.uploadEvidence.showEvidenceDialog = true
      this.showUploadEvidenceDailog = true;
    },
    downAllFile(type, item) {
      let fileIds = [],
        fileName = "";
      if (type == "applicant") {
        this.applicantMaterial.forEach((element) => {
          fileIds.push(element.id);
        });
        fileName = "申请人/代理人举证.zip";
      } else if (type == "respondent") {
        this.respondentMaterial.forEach((element) => {
          fileIds.push(element.id);
        });
        fileName = "被申请人/代理人举证.zip";
      } else if (type == "mediator") {
        this.mediatorMaterial.forEach((element) => {
          fileIds.push(element.id);
        });
        fileName = "其他材料举证.zip";
      }
      filedownload(
        "/gzzc/docBook/batchDownLoad",
        {
          ids: fileIds,
          caseId: this.$route.query.caseid,
        },
        fileName
      );
    },
    downfile(type, item) {
      let fileName = "";
      if (type === "applicant") {
        fileName = "申请人/代理人举证.zip";
      } else if (type == "respondent") {
        fileName = "被申请人/代理人举证.zip";
      } else if (type == "mediator") {
        fileName = "其他材料举证.zip";
      }
      filedownload(
        "/gzzc/docBook/batchDownLoad",
        {
          ids: item.id,
          caseId: this.$route.query.caseid,
        },
        fileName
      );
    },
    handleCheck(item) {
      this.upType = 'addFile'
      this.detailBean = item;
      this.dialogCaseinfoImg = true;
    },
    detelEvidenceFile(item) {
      let params = {
          id: item.id,
          fileId: item.fileId
      }
      if (item.delFlag === false) {
          params.fileName = item.fileName,
          params.delFlag = item.delFlag
      }
      delEvidenceDetails(params).then((res) => {
        if (res.data.code === 1000) {
          this.getList()
          if (item.delFlag === false) {
              this.dialogCaseinfoImg = false
              this.upfilelist = []
              this.$message({
                  type: "success",
                  message: "添加成功",
              });
          } else {
              this.$message({
                  type: "success",
                  message: "删除成功",
              });
          }
        }
      });
    },
    handleClose() {
      this.dialogCaseinfoImg = false;
      this.showUploadEvidenceDailog = false;
    },
    comcallback() {
      this.showCrossExamination = false;
    },
    //获取证据列表
    getList() {
      queryLawAttachmentList({
        caseId: this.$route.query.caseid,
        meetingId: this.$route.query.meetingid,
      })
        .then((res) => {
          console.log(res);
          if (res.data.code === 1000) {
            let resData = res.data.data;
            let applicantMaterial = [],
              respondentMaterial = [],
              mediatorMaterial = [];
            for (let index in resData) {
              let item = resData[index];
              item.fileId = item.fileInfo.map((i) => {
                return i.fileId;
              });
              item.allowDel = Boolean(
                resData[index].creatorId == this.currentUserId
              );
              // console.log(item.allowDel)
              if (this.isWorker) {
                item.allowDel = true;
              }
              if (
                item.categorySmall === "APPLICANT" ||
                item.categorySmall === "APPLICANT_AGENT"
              ) {
                applicantMaterial.push(item);
              } else if (
                item.categorySmall === "RESPONDENT" ||
                item.categorySmall === "RESPONDENT_AGENT"
              ) {
                respondentMaterial.push(item);
              } else {
                mediatorMaterial.push(item);
              }
              // 如果是工作人员。展示“质证记录”
              // 如果是用户，自己的文件展示“质证记录”
              // 用户的非自己文件，根据evidenceStatus 判断。1代表未质证。
              if (this.isWorker) {
                item.isCrossExaminationRecord = true;
              } else {
                if (item.allowDel) {
                  item.isCrossExaminationRecord = true;
                } else {
                  if (item.evidenceStatus === "1") {
                    item.isCrossExaminationRecord = false;
                  } else {
                    item.isCrossExaminationRecord = true;
                  }
                }
              }
            }
            this.applicantMaterial = applicantMaterial;
            this.respondentMaterial = respondentMaterial;
            this.mediatorMaterial = mediatorMaterial;
            // console.log(this.applicantMaterial)
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getAttachmentList() {
      searchDictionaryInfo({
        parentCode: "zcAttachmentList",
      }).then((res) => {
        if (res.data.code == 1000) {
          this.attachmentList = res.data.data;
        }
      });
    },
    delfile(item) {
      console.log(item)
      if (this.isClosed) return;
      this.$alert("是否继续删除该文件?", "温馨提示", {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            delMediationMaterial({
              caseId: this.$route.query.caseid,
              id: item.id,
            }).then(
              (res) => {
                console.log(res)
                instance.confirmButtonLoading = false;
                if (res.data.code === 1000) {
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });
                  this.getList();
                  done();
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.message,
                  });
                  done();
                }
              },
              (err) => {
                instance.confirmButtonLoading = false;
              }
            );
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    close(){
      this.dialogCaseinfoImg = false;
    }
  },
  filters: {
    attachmentType: function (value) {
      let type;
      const filesType = {
        DOCUMENT_MATERIAL: "文书材料",
        EVIDENCE_INVENTORY: "证据清单",
        IDENTITY_CERTIFICATE: "身份证明",
        OTHER: "其他",
      };
      if (new RegExp("[A-Za-z]+").test(value)) {
        type = filesType[value];
      } else {
        type = value;
      }
      return type;
    },
  },
};
</script>

<style lang="scss">
.dialog-caseinfo {
  text-align: center;
  // img {
  //     margin: 0 auto;
  //     display: block;
  // }
}

.material-list {
  margin: 26px 40px 0 65px;

  .upload-btn {
    margin: 0 auto 50px;
    display: block;
    background-color: #1e6dcb;
    border-color: #1e6dcb;
  }
}

.material-block {
  padding-bottom: 40px;

  .tit {
    font-size: 20px;
    color: #333333;
    position: relative;
    padding-left: 12px;
    margin-bottom: 30px;

    &:before {
      position: absolute;
      content: "";
      width: 4px;
      height: 20px;
      background-color: #1e6dcb;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .row-fileName-ov {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  thead {
    height: 50px;
    color: #333333;
    font-size: 16px;

    th {
      background-color: #f1f3f5;
    }
  }
}

.row-fileName {
  max-width: 500px;
}
.el-tooltip__popper {
  width: 300px; /*修改宽度*/
  padding: 20px;
  background: #fff !important; /*背景色  !important优先级*/
  opacity: 0.8 !important; /*背景色透明度*/
  color: #333333 !important; /*字体颜色*/
  box-shadow: 0 4px 4px #666 0px 0px 10px #666 outset !important;
  //box-shadow:2px 2px 5px #000;
}
.bg-purple-dark {
  background: #ccc;
}
.dialogContainer {
  display: flex;
//line-height: 40px;
  margin-right: 10px;
  font-size: 16px;
  color: #333333;

.dialogContent {
  width: 100px;
  height: 20px;
  line-height: 40px;
}
.uploadContent {
  flex: 1;
.el-upload-dragger{
  width: 100%;
  height: 100%;
  border: none;
// border-radius: 1px;
}
.warn{
  margin-top: 10px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #606266;
  margin-bottom: 10px;
}
.el-btn-upload{
  width: 100px;
  font-size: 14px;
  border: 1px solid #006CD2;
  height: 36px;
  line-height: 36px;
  color: #1E6DCB;
  text-align: center;
}
.excelTemplate{
  width: 120px;
  font-size: 14px;
  text-align: left;
  color: #006CD2;
}
.el-upload-list__item{
  margin-top: 6px;
  font-size: 14px;
  background-color: #EFEFEF;
}
}
}
.dialog-footer{
.confirm_ca{
  border-radius: 0;
  border: 1px solid  #1E6DCB;
  color: #1E6DCB;
}
.confirm_re{
  margin-left:20px;
  border-radius: 0;
  background: #1E6DCB;
  color: #fff;
}
}
</style>
